import React, { useState, useEffect, useCallback,useRef } from "react";
import { SelectBox } from "devextreme-react/select-box";
import routes from "../../../assets/apiRoutes.json";
import { Button } from "devextreme-react/button";
import { Popup } from "devextreme-react/popup";
import notify from "devextreme/ui/notify";
import { connect } from "react-redux";
import { confirm } from 'devextreme/ui/dialog';
import { alert } from 'devextreme/ui/dialog';
import _ from "lodash";
import { GetDatePartOnlyDiffFormat, GetTimePartOnly } from "../../../common/Utils.js";
import { GridLayout } from "../../../common/GridLayout";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

import axios from "axios";
var accessToken;
const ReviewChangeOrderList = (props) => {
const dataGrid = useRef(null);
  accessToken = props.oidc.user.access_token;
  const [loadReviewChangesRequest, setLoadReviewChangesRequesl] = useState({
    queryAndInsertMasterChangeInOrderToReview: false,
    queryAndInsertMasterRecordsToDelete: false,
    queryAndInsertRecordCounts: false,
  });

  const [reviewNewOrderList, setReviewNewOrderList] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const loadReviewOrders = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.pu_processing.LoadReviewChanges
        }?lookup=${1}`,
        loadReviewChangesRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken
          }
        }
      )
      .then((res) => {
        console.log(res, "new order response");
        var changes = res.data.data;

        var result = _.map(changes, function (o, i) {
          var eq = _.find(changes, function (e, ind) {
            if (i == changes.length - 1) {
              if (i > ind) {
                return o.salesorder === e.salesorder &&
                  o.salesorderline === e.salesorderline
                  ? true
                  : false;
              }
            }
            if (i < ind) {
              return o.salesorder === e.salesorder &&
                o.salesorderline === e.salesorderline
                ? true
                : false;
            }
          });
          if (eq) {
            o.isDuplicate = true;
            return o;
          } else {
            return o;
          }
        });
        console.log(result);
        setReviewNewOrderList(result);
      })
      .catch((err) => {
        console.log(err, "err in new order response");
      });
  };
  useEffect(() => {
    loadReviewOrders();
  }, []);

  const releaseReviewOrders = () => {

    var rowsData = dataGrid.current.instance().getSelectedRowsData();
    if (rowsData == null || rowsData.length == 0) {
      alert("Please select at least one record.", "Error");
      return;
    }

    let result = confirm("<i>Release selected records. Do you wish to continue?</i>", "Release All");
    result.then((dialogResult) => {
      if (dialogResult) {
        var rowIds = new Array();
        for (let index = 0; index < rowsData.length; index++) {
          rowIds.push(rowsData[index].rowid);
        }
        axios
          .post(
            `${window._env_.REACT_APP_APIS}/${routes.pu_processing.ReleaseReviewOrders}?lookup=${1}`,
            rowIds,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              }
            }
          )
          .then((res) => {
            console.log(res, "realead review order");
            reviewStatusObject.loadReviewOrders();
            reviewStatusObject.setReleaseorDeleteOrderReq({
              orderStaus: "",
              rowid: "",
            });
          })
          .catch((err) => {
            console.log(err, "err in releasing");
          });
      }
    });




  };

  const deleteReviewOrders = () => {

    var rowsData = dataGrid.current.instance().getSelectedRowsData();
    if (rowsData == null || rowsData.length == 0) {
      alert("Please select at least one record.", "Error");
      return;
    }

    let result = confirm("<i>Delete selected records. Do you wish to continue?</i>", "Delete All");
    result.then((dialogResult) => {
      if (dialogResult) {
        var rowIds = new Array();
        for (let index = 0; index < rowsData.length; index++) {
          rowIds.push(rowsData[index].rowid);
        }
        axios
          .post(
            `${window._env_.REACT_APP_APIS}/${routes.pu_processing.DeleteReviewOrders}`,
            rowIds,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              }
            }
          )
          .then((res) => {
            console.log(res, "realead review order");
            reviewStatusObject.loadReviewOrders();
            reviewStatusObject.setReleaseorDeleteOrderReq({
              orderStaus: "",
              rowid: "",
            });
          })
          .catch((err) => {
            console.log(err, "err in releasing");
          });
      }
    });
  };

  const [orderStatus, setOrderStatus] = useState("");
  const [releaseorDeleteOrderReq, setReleaseorDeleteOrderReq] = useState({
    orderStatus: "",
    rowid: "",
  });
  const [openStatusdialog, setOpenStatusDialog] = useState(false);

  var reviewStatusObject = {
    openStatusdialog: openStatusdialog,
    setOpenStatusDialog: setOpenStatusDialog,
    reviewNewOrderList: reviewNewOrderList,
    setReviewNewOrderList: setReviewNewOrderList,
    orderStatus: orderStatus,
    setOrderStatus: setOrderStatus,
    releaseorDeleteOrderReq: releaseorDeleteOrderReq,
    setReleaseorDeleteOrderReq: setReleaseorDeleteOrderReq,
    loadReviewOrders: loadReviewOrders,
    isVisible: isVisible,
  };

  const allowedPageSizes = [10, 100, 200, 500, "all"];
  const gridKey = "d3b4b276-0efa-4233-9069-7e8f89339da3";
  const [currentLayout, setCurrentLayout]= useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
     
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    

  return (
    <div>
      <div className="release-btn-wrapper">
        <Button
          type="default"
          onClick={deleteReviewOrders}
          className="release-btn"
        >
          Delete All
        </Button>
        <Button
          type="default"
          onClick={releaseReviewOrders}
          className="release-btn"
        >
          Release All
        </Button>
      </div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        height={"calc(100vh - 200px)"}
        noDataText=""
        allowColumnReordering={true}
        allowColumnResizing={true}
        dataSource={reviewNewOrderList}
        showBorders={true}
        className="customDataTableDesign reviewgrid"
        hoverStateEnabled={true}
        searchExpr="status"
        keyExpr="rowid"
        searchEnabled={true}
      >
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} />
        <Selection mode="multiple" />
        <Sorting visible={true} mode="multiple" />
        <Paging defaultPageSize={100} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
          showInfo={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter enabled={true} visible={false} />
        <GroupPanel emptyPanelText="Review New Orders" visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column
          dataField="rowid"
          caption="Status"
          cellRender={(rowid) => renderStatusField(rowid, reviewStatusObject)}
        ></Column>
        <Column
          dataField="salesorder"
          headerCellRender={renderSalesorderHeader}
          cellRender={renderSalesorder}
        ></Column>
        <Column
          dataField="hdrcreationdate"
          headerCellRender={renderHdrCreationDateHeader}
          cellRender={renderHdrCreationDate}
        ></Column>
        <Column
          dataField="creationdatetime"
          headerCellRender={renderLineCreationDateHeader}
          cellRender={renderLineCreationDate}
        ></Column>
        <Column
          dataField="prodlot"
          headerCellRender={renderProductionLotHeader}
          cellRender={renderProductionLot}
        ></Column>
        <Column
          dataField="color"
          headerCellRender={renderColorHeader}
          cellRender={renderColor}
        ></Column>
        <Column
          dataField="oversow"
          headerCellRender={renderOversowHeader}
          cellRender={renderOversow}
        ></Column>
        <Column
          dataField="customername"
          headerCellRender={renderCustomerNameHeader}
          cellRender={renderCustomerName}
        ></Column>
        <Toolbar>
        <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                 </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
};
const renderSalesorder = (data) => {
  if (data.data.isDuplicate) {
    return <div><div className="yellow-background">{data.data.salesorder}-{data.data.salesorderline}</div><div>{data.data.salesrep}</div></div>;
  }
  if (!data.data.isDuplicate) {
    return <div><div>{data.data.salesorder}-{data.data.salesorderline}</div><div>{data.data.salesrep}</div></div>;
  }
};

const renderSalesorderHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Order # - Line</div><div>Sales Rep</div></div>;
};
const renderHdrCreationDateHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Header Creation Date</div><div>Order Quantity   Index</div></div>;
};
const renderHdrCreationDate = (data) => {
  var formattedDate = GetDatePartOnlyDiffFormat(data.data.hdrcreationdate, '/') + " " + GetTimePartOnly(data.data.hdrcreationdate);
  return <div><div>{formattedDate}</div><div>{data.data.orderquantity.toLocaleString('en-US')}   {data.data.indexnumber}</div></div>;
};

const renderLineCreationDateHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Line Creation Date</div><div>Date Modified</div></div>;
};
const renderLineCreationDate = (data) => {
  var formattedDate1 = GetDatePartOnlyDiffFormat(data.data.creationdatetime, '/') + " " + GetTimePartOnly(data.data.creationdatetime);
  var formattedDate2 = GetDatePartOnlyDiffFormat(data.data.lastupdatedatetime, '/') + " " + GetTimePartOnly(data.data.lastupdatedatetime);
  return <div><div>{formattedDate1}</div><div>{formattedDate2}</div></div>;
};

const renderProductionLotHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Production Lot</div><div>Sales Item</div></div>;
};
const renderProductionLot = (data) => {
  return <div><div>{data.data.prodlot}</div><div>{data.data.salesitem}</div></div>;
};

const renderColorHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Color</div><div>Symbol</div></div>;
};
const renderColor = (data) => {
  return <div><div>{data.data.color}</div><div>{data.data.symbol}</div></div>;
};
const renderOversowHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Over Sow - Species</div><div>Cell Type - Facility</div></div>;
};
const renderOversow = (data) => {
  return <div><div>{data.data.oversow} - {data.data.species}</div><div>{data.data.celltype} - {data.data.facility}</div></div>;
};

const renderCustomerNameHeader = () => {
  return <div className="dx-datagrid-text-content dx-text-content-alignment-left" role="presentation"><div>Customer Name</div><div>Comment</div></div>;
};
const renderCustomerName = (data) => {
  return <div><div>{data.data.customername}</div><div>{data.data.comment}</div></div>;
};

const renderStatusField = (rowid, reviewStatusObject) => {
  console.log(reviewStatusObject, "order list");
  const onValueChanged = (e) => {

    if (e.component.__ignoreEvent) {
      e.component.__ignoreEvent = false;
      return;
    }

    if (e.value.name != "Release" && e.value.name != "Delete") {
      e.component.__ignoreEvent = true;
      e.component.option("value", e.previousValue);
    }
    else {
      reviewStatusObject.setOrderStatus(e.value.name);
      reviewStatusObject.setOpenStatusDialog(true);
      reviewStatusObject.setReleaseorDeleteOrderReq({
        orderStatus: e.value.name,
        rowid: e.value.rowid,
      });
    }
  };

  var orderStatusObj = [
    { name: "Release", rowid: rowid.data.rowid },
    { name: "Delete", rowid: rowid.data.rowid },
    { name: "OnReleased", rowid: rowid.data.rowid },
    { name: "OnLotSelected", rowid: rowid.data.rowid },
    { name: "OnLotAssigned", rowid: rowid.data.rowid },
    { name: "OnPullOrder", rowid: rowid.data.rowid },
    { name: "OnDryStrat", rowid: rowid.data.rowid },
    { name: "OnStratComplete", rowid: rowid.data.rowid },
    { name: "OnShipped", rowid: rowid.data.rowid },
    { name: "OnStratPending", rowid: rowid.data.rowid },
    { name: "N/A", rowid: rowid.data.rowid }
  ];

  var currentStatusIndex = 10;
  switch (rowid.data.orderstatus) {
    case "Release":
    case "release":
      currentStatusIndex = 0;
      break;
    case "Delete":
    case "delete":
      currentStatusIndex = 1;
      break;
    case "OnReleased":
    case "onreleased":
      currentStatusIndex = 2;
      break;
    case "OnLotSelected":
    case "onlotselected":
      currentStatusIndex = 3;
      break;
    case "OnLotAssigned":
    case "onlotassigned":
      currentStatusIndex = 4;
      break;
    case "OnPullOrder":
    case "onpullorder":
      currentStatusIndex = 5;
      break;
    case "OnDryStrat":
    case "ondrystrat":
      currentStatusIndex = 6;
      break;
    case "OnStratComplete":
    case "onstratcomplete":
      currentStatusIndex = 7;
      break;
    case "OnShipped":
    case "onshipped":
      currentStatusIndex = 8;
      break;
    case "OnStratPending":
    case "onstratPending":
      currentStatusIndex = 9;
      break;
    case "N/A":
    case "n/a":
      currentStatusIndex = 10;
      break;
  }

  var recCountClass = "";
  if (rowid.data.isDuplicate) {
    recCountClass = "yellow-background";
  }

  const releaseDeleteOrder = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.pu_processing.DeleteReviewOrder}?lookup=${1}`,
        reviewStatusObject.releaseorDeleteOrderReq,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          }
        }
      )
      .then((res) => {
        console.log(res, "delete review order");
        notify({
          message: `The order has been ${reviewStatusObject.orderStatus}d Successfully! `,
          width: 450,
          type: "info",
          displayTime: 1400,
        });
        reviewStatusObject.loadReviewOrders();
        reviewStatusObject.setOpenStatusDialog(false);
        reviewStatusObject.setReleaseorDeleteOrderReq({
          orderStaus: "",
          rowid: "",
        });
      })
      .catch((err) => {
        console.log(err, "error in deletion");
      });
  };
  const closeStatusDialog = () => {
    reviewStatusObject.setOpenStatusDialog(false);
  };

  return (
    <div>
      <SelectBox
        dataSource={orderStatusObj}
        displayExpr="name"
        defaultValue={orderStatusObj[currentStatusIndex]}
        onValueChanged={(e) => onValueChanged(e)}
      ></SelectBox>
      <div className={recCountClass} style={{marginTop: '3px', paddingLeft: '2px'}}>{rowid.data.reccount == null ? "" : rowid.data.reccount}</div>
      <Popup
        visible={reviewStatusObject.openStatusdialog}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showTitle={false}
        showCloseButton={false}
        onHiding={closeStatusDialog}
        title="Update Record"
        container=".dx-viewport"
        width={450}
        height={180}
      >
        <div style={{ padding: '20px' }}>
          <h6 className="update-dialog-title" style={{ marginTop: '0', marginBottom: '15px', fontSize: '18px' }}>
            {reviewStatusObject.orderStatus} Order!
          </h6>
          <p className="dialog-heading" style={{ marginBottom: '20px', fontSize: '14px' }}>
            Do You want to {reviewStatusObject.orderStatus} the order ?
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <Button
              text="Yes"
              type="default"
              onClick={() => releaseDeleteOrder()}
            />
            <Button
              text="No"
              onClick={closeStatusDialog}
            />
          </div>
        </div>
      </Popup>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ReviewChangeOrderList);
